"use client";
import React from "react";
import AppInitializer from "@/store/AppInitializer";
import { MantineProvider } from "@mantine/core";
//import posthog from 'posthog-js'

//posthog.init('phc_ad3ccGKn56TYr02aky4T1WKaCC7z3rX3xWiuUap6Pa1', { api_host: 'https://eu.posthog.com' })

export default function Providers({ children }: { children: React.ReactNode }) {
  //posthog.capture('pageload')
  return (
    <MantineProvider>
      <AppInitializer />
      {children}
    </MantineProvider>
  );
}
